module.exports = __webpack_public_path__ + "images/c6447df27a4be62de195ab20f95c8ecb.svg";